import { proxyCustomElement, HTMLElement, h, Fragment } from '@stencil/core/internal/client';
import { C as CURRENT_MODULE } from './index2.js';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlWelcomeSignupCss = baseCss;

const NlWelcomeSignupStyle0 = nlWelcomeSignupCss;

const NlWelcomeSignUp = /*@__PURE__*/ proxyCustomElement(class NlWelcomeSignUp extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.titleWelcome = 'Sign up';
        this.description = 'Nostr profiles are based on cryptographic keys. You can create keys right here, or with a key storage app.';
    }
    handleChangeScreen(screen) {
        state.path = [...state.path, screen];
    }
    render() {
        return (h(Fragment, { key: 'ed92b261515733ad30246febe996bec581f392ee' }, h("div", { key: 'f8e1c53b93a766e1c086b0c0fca9fae98f6e492c', class: "p-4 overflow-y-auto" }, h("h1", { key: '8766733352e5a129016b6a9cdfeeeac06af00be1', class: "nl-title font-bold text-center text-3xl" }, this.titleWelcome), h("p", { key: 'b758d37bcd4e09eaf981ef3057a437872b5ca5cb', class: "nl-description font-light text-center text-lg pt-2 max-w-96 mx-auto" }, this.description)), h("div", { key: 'ffb223d49d4f380406cb4eec4d9f166b7ba7694c', class: "max-w-52 mx-auto pb-5" }, h("div", { key: '871ce44d253799caf575263f6e3d42227f9e24ad', class: "flex gap-3 flex-col" }, h("button-base", { key: '345b1aaebcc7c72811ab1a7e9a010c011066e1fb', onClick: () => this.handleChangeScreen(CURRENT_MODULE.LOCAL_SIGNUP), titleBtn: "Create keys" }, h("svg", { key: '17f0f693941020e1ad09c64e8e80ca08fd082673', style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { key: '0720ef9137e48e3b814ea1efa463925dfb3ee5e1', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" }))), h("button-base", { key: '09f0ac2ad4b759b29001d28d735a74300fee2c36', onClick: () => this.handleChangeScreen(CURRENT_MODULE.SIGNUP), titleBtn: "With key store" }, h("svg", { key: '207439f7318c9dfd7ed8a70da9099ed1a8121871', style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { key: '9331b09772ce53fe1802a00063646f68ffb8971a', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" })))))));
    }
    static get style() { return NlWelcomeSignupStyle0; }
}, [0, "nl-welcome-signup", {
        "titleWelcome": [1, "title-welcome"],
        "description": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-welcome-signup", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-welcome-signup":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlWelcomeSignUp);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlWelcomeSignUp as N, defineCustomElement as d };

//# sourceMappingURL=nl-welcome-signup2.js.map